<prime-dialog [visible]="visible()" [closable]="false" [breakpoints]="breakpoints" [style]="styles">
  <div dialog-body>
    <header class="header">
      <img class="icon" [src]="icon()" alt="Icono de error">
      <p class="title">{{title()}}</p>
      <div class="bar"></div>
    </header>
    <div class="message">
      <ng-content></ng-content>
    </div>
    <prime-button classes="block w-9 mx-auto" label="Aceptar" (click)="handleClose()" />
  </div>
</prime-dialog>
